import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const { login }              = useAuth();
  const navigate               = useNavigate();
  const [email,    setEmail]   = useState('');
  const [password, setPassword]= useState('');
  const [confirm,  setConfirm] = useState('');
  const [loading,  setLoading] = useState(false);
  const [error,    setError]   = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }

    setLoading(true);
    try {
      const res  = await fetch('/users/register', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ email, password }),
      });
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Registration failed');
      }

      // Auto-login after register
      await login(email, password);
      navigate('/onboarding');

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const inputStyle = {
    width:           '100%',
    padding:         '12px 16px',
    backgroundColor: '#0C1A36',
    border:          '1px solid #2A3F5F',
    borderRadius:    '8px',
    color:           '#EDF1FF',
    fontSize:        '1rem',
    boxSizing:       'border-box',
    outline:         'none',
  };

  const labelStyle = {
    display:      'block',
    color:        '#EDF1FF',
    fontSize:     '0.875rem',
    marginBottom: '8px',
    fontWeight:   600,
  };

  return (
    <div style={{
      minHeight:      '100vh',
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      backgroundColor:'#0C1A36',
      fontFamily:     'Sora, sans-serif',
    }}>
      <div style={{
        backgroundColor: '#112240',
        borderRadius:    '12px',
        padding:         '48px',
        width:           '100%',
        maxWidth:        '440px',
        boxShadow:       '0 20px 60px rgba(0,0,0,0.4)',
      }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '8px' }}>
          <div style={{ fontSize: '1.8rem', fontWeight: 800 }}>
            <span style={{ color: '#1A7FBE' }}>Acct</span>
            <span style={{ color: '#F5C800' }}>4</span>
            <span style={{ color: '#3DAA4A' }}>Cast</span>
          </div>
          <p style={{ color: '#7A90B8', fontSize: '0.875rem', marginTop: '6px' }}>
            Create your account — free for 14 days
          </p>
        </div>

        {/* Steps indicator */}
        <div style={{
          display:       'flex',
          justifyContent:'center',
          gap:           '8px',
          margin:        '20px 0 28px',
        }}>
          {['Create Account', 'Connect QB', 'Subscribe'].map((s, i) => (
            <div key={s} style={{
              display:    'flex',
              alignItems: 'center',
              gap:        '6px',
              fontSize:   '0.7rem',
              color:      i === 0 ? '#00A8CC' : '#4A5568',
              fontWeight: i === 0 ? 700 : 400,
            }}>
              <div style={{
                width:        '20px',
                height:       '20px',
                borderRadius: '50%',
                background:   i === 0 ? 'linear-gradient(135deg,#00A8CC,#3DAA4A)' : '#1E3A5F',
                display:      'flex',
                alignItems:   'center',
                justifyContent:'center',
                color:        '#fff',
                fontSize:     '0.65rem',
                fontWeight:   700,
              }}>
                {i + 1}
              </div>
              {s}
              {i < 2 && <span style={{ color: '#2A3F5F' }}>›</span>}
            </div>
          ))}
        </div>

        {/* Error */}
        {error && (
          <div style={{
            background:   '#2D1B1B',
            border:       '1px solid #C0223A',
            borderRadius: '8px',
            padding:      '12px 16px',
            marginBottom: '20px',
            color:        '#FF6B6B',
            fontSize:     '0.875rem',
          }}>
            {error}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '18px' }}>
            <label style={labelStyle}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="you@company.com"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '18px' }}>
            <label style={labelStyle}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              placeholder="Min 8 characters"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '28px' }}>
            <label style={labelStyle}>Confirm Password</label>
            <input
              type="password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              required
              placeholder="Repeat password"
              style={inputStyle}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width:        '100%',
              padding:      '14px',
              background:   'linear-gradient(135deg, #00A8CC, #3DAA4A)',
              border:       'none',
              borderRadius: '8px',
              color:        '#fff',
              fontSize:     '1rem',
              fontWeight:   700,
              cursor:       loading ? 'not-allowed' : 'pointer',
              opacity:      loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Creating account...' : 'Create Account →'}
          </button>
        </form>

        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <div style={{ color: '#7A90B8', fontSize: '14px', marginBottom: '12px' }}>
            — or —
          </div>
          <button
            onClick={() => { window.location.href = window.location.origin + '/auth/google'; }}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              padding: '10px 20px',
              background: '#ffffff',
              border: '1px solid #CCCCCC',
              borderRadius: '6px',
              color: '#222222',
              fontSize: '15px',
              fontFamily: 'Sora, sans-serif',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 48 48">
              <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.2l6.7-6.7C35.8 2.5 30.2 0 24 0 14.7 0 6.7 5.4 2.6 13.4l7.8 6.1C12.4 13.1 17.7 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.1 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h12.4c-.5 2.8-2.2 5.2-4.7 6.8l7.3 5.7c4.3-4 6.8-9.9 6.8-16.5z"/>
              <path fill="#FBBC05" d="M10.4 28.5C9.8 26.8 9.5 25 9.5 23s.3-3.8.9-5.5l-7.8-6.1C.9 14.8 0 18.3 0 22c0 3.7.9 7.2 2.6 10.2l7.8-6.1z"/>
              <path fill="#34A853" d="M24 48c6.2 0 11.4-2 15.2-5.5l-7.3-5.7c-2 1.4-4.6 2.2-7.9 2.2-6.3 0-11.6-3.6-13.6-9l-7.8 6.1C6.7 42.6 14.7 48 24 48z"/>
            </svg>
            Continue with Google
          </button>
        </div>

        <p style={{ textAlign: 'center', color: '#7A90B8', fontSize: '0.8rem', marginTop: '20px' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#00A8CC', textDecoration: 'none' }}>
            Sign in
          </Link>
        </p>

        <p style={{ textAlign: 'center', color: '#4A5568', fontSize: '0.7rem', marginTop: '12px' }}>
          By signing up you agree to our Terms of Service
        </p>
      </div>
    </div>
  );
}